import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  card: {
    // A two-column label/value grid, not a table: each value carries its own label, so a
    // card read in isolation still says what its numbers are.
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gap: theme.spacing(0.5, 2),
    alignItems: 'baseline',
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    // A FLAT card, matching OverviewTableMobile one directory away rather than MUI Paper's
    // default elevation. Two sibling screens whose comments call each other references should
    // not render the same idea with and without a shadow.
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8
  },
  listHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(0.5)
  },
  cardLabel: {
    color: theme.palette.text.secondary
  },
  unattributed: {
    color: theme.palette.text.secondary,
    fontStyle: 'italic'
  }
}))

export default useStyles
